<template>
  <div class="container-fluid row">
    <!-- <div class="col mb-3 mt-3" style="text-align: right">
      <a>
        <button
          type="button"
          id="get_file"
          class="btn btn-success btn-sm"
          @click="getid(0)"
          data-bs-toggle="modal"
          data-bs-target="#AddUser"
        >
          <i class="fa fa-plus"></i> เพิ่มผู้รับผิดชอบรายวิชา
        </button></a
      >
    </div> -->
    <div class="col-md-12 mb-3 mt-3" style="margin: 15px;">
    <table class="table table-bordered">
      <thead>
        <tr class="table-active">
          <th scope="col">ลำดับที่</th>
          <th scope="col">ชื่อ-นามสกุล</th>
          <th scope="col"> คณะ</th>
          <th scope="col"> หลักสูตร</th>
           <th scope="col">เพศ</th>
           <th scope="col">สุขภาพ</th>
           <th scope="col">maxS</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody v-if="proctor.length == 0">
        <td style="text-align: center;" colspan="8">ไม่พบข้อมูล</td> 
        </tbody>
      <tbody v-else>
        <tr v-for="(l, i) in proctor" :key="i">
          <td>
            {{ i + 1 }}
          </td>
          <td>
            {{ l.firstname }}
          </td>
          <td>
            {{ l.faculty }}
          </td>
          <td>
            {{ l.course }}
          </td>
          <td>{{ l.sex }}</td>
          <td>{{ l.health }}</td>
          <td>{{ l.maxS }}</td>
          <td>
            <a @click="getid(l.id)">
              <button
                type="button"
                class="btn btn-warning btn-sm"
                data-bs-toggle="modal"
                data-bs-target="#AddUser"
              >
                <i class="fa fa-edit"></i></button
            ></a>&nbsp;
            <!-- <a @click="deletedata(l.id)">
              <button
                type="button"
                class="btn btn-danger btn-sm"
                data-bs-toggle="modal"
                data-bs-target="#DeleteStatus"
              >
                <i class="fa fa-trash"></i></button
            ></a> -->
          </td>
        </tr>
      </tbody>
    </table>
    </div>
    <!-- Modal -->
    <div
      class="modal fade"
      id="AddUser"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">{{ title }}</h5>
            <button
              id="closeduser"
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <form>
              <div class="card-body mt-3">
                <div class="form-group">
                  <label for="username">ชื่อ-นามสกุล</label>
                  <input
                    v-model="instructor.firstname"
                    type="text"
                    min="1"
                    class="form-control form-control-sm"
                    id="username"
                  />
                </div>
                <div class="form-group mt-3">
          <label for="exampleFormControlSelect1">คณะ</label>
          <select
            v-model="instructor.faculty_id"
            class="form-select form-control-sm"
            id="exampleFormControlSelect1"
            @change="getCoursesByFaculty"
          >
            <option v-for="(s, i) in faculty" v-bind:value="s.id" :key="i + 1">
              {{ s.nameTH }}
            </option>
          </select>
        </div>
        <div class="form-group mt-3">
          <label for="exampleFormControlSelect1">หลักสูตร</label>
          <select
            v-model="instructor.course_id"
            class="form-select form-control-sm"
            id="exampleFormControlSelect1"
            @change="getFacultyByCourses"
          >
            <option v-for="(s, i) in courselist" v-bind:value="s.id" :key="i + 1">
              {{ s.nameTH }}
            </option>
          </select>
        </div>
         <div class="form-group mt-3">
          <label for="exampleFormControlSelect1">เพศ</label>
          <select
            v-model="instructor.sex"
            class="form-select form-control-sm"
            id="exampleFormControlSelect1"
          >
            <option value="M">
              M
            </option>
             <option value="F">
              F
            </option>
          </select>
        </div>
        <div class="form-group mt-3">
          <label for="exampleFormControlSelect1">สุขภาพ</label>
          <select
            v-model="instructor.health"
            class="form-select form-control-sm"
            id="exampleFormControlSelect1"
          >
            <option value="0">
              0
            </option>
             <option value="1">
              1
            </option>
          </select>
        </div>
        <div class="form-group">
                  <label for="username">maxS</label>
                  <input
                    v-model="instructor.maxS"
                    type="text"
                    min="1"
                    class="form-control form-control-sm"
                    id="username"
                  />
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer mt-3">
            <button type="button" class="btn btn-success btn-sm" @click="save()">
              บันทึก
            </button>
            <button
              type="button"
              class="btn btn btn-secondary btn-sm"
              data-bs-dismiss="modal"
            >
              ปิด
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="DeleteStatus"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">ยืนยันการลบข้อมูล</h5>
          </div>
          <div class="modal-footer mt-3">
            <button type="button" class="btn btn-danger btn-sm" @click="deletebyid()">
              <label>ลบข้อมูล</label>
            </button>
            <button
            id="closeddeleteuser"
              type="button"
              class="btn btn-secondary  btn-sm"
              data-bs-dismiss="modal"
            >
              ปิด
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserService from "../services/UserService";
import ProctorService from "../services/ProctorService";
import FacultyService from "../services/FacultyService";
import CourseService from "../services/CourseService";

export default {
  name: "Nav",
  props: {
    msg: String,
  },
  data() {
    return {
      concert_id: 0,
      list: [],
      user: {},
      user_id: 0,
      hash: 0,
      title: "",
      roles:[],
      delete_id:0,
      proctor:[],
      faculty: [],
      instructor:{},
      instructor_id:0,
      courselist:[],
      course:[]
    };
  },
  mounted() {
    this.getRoles()
    this.getProctor()
    this.getFaculty();
    this.getCourse();
  },
  methods: {
    getFacultyByCourses(){
      const facultylist = this.course.find(c =>
        c.id === this.instructor.course_id
      );
      this.instructor.faculty_id = facultylist.faculty_id;
    },
    getCoursesByFaculty(){
      const courselist = this.course.filter(c =>
        c.faculty_id === this.filter.faculty_id
      );
      this.courselist = courselist;
    },
    getCourse(){
      CourseService.getCourses().then((res) => {
        this.course = res.data;
        this.courselist = res.data;
        console.log(res.data);
      });
    },
    getFaculty(){
      FacultyService.getFacultys().then((res) => {
        this.faculty = res.data;
        console.log(res.data);
      });
    },
    getProctor(){
      ProctorService.getProctors().then((res) => {
        this.proctor = res.data;
        console.log(res.data);
      });
    },
    deletedata(id){
      this.delete_id = id;
    },
     getRoles() {
      UserService.getRolesAll().then((res) => {
        console.log(res.data);
        this.roles = res.data;
      });
    },
    getid(id) {
      this.instructor_id = id;
      if (this.instructor_id != 0) {
        this.title = "แก้ไขข้อมูลผู้รับผิดชอบรายวิชา";
        ProctorService.getProctor(this.instructor_id).then((res) => {
          this.instructor = res.data;
        });
      } else {
        this.title = "เพิ่มข้อมูลผู้รับผิดชอบรายวิชา";
        this.instructor = [];
      }
    },
    save() {
      if (this.instructor.firstname == null) {
        alert("กรุณากรอกชื่อ-นามสกุล");
      } else if (this.instructor.faculty_id == null) {
        alert("กรุณาเลือกคณะ");
      }  else if (this.instructor.sex == null) {
        alert("กรุณาเลือกเพศ");
      }  else if (this.instructor.maxS == null) {
        alert("กรุณากรอก maxS");
      }else {
        var instructordata = {
          firstname: this.instructor.firstname,
          faculty_id: this.instructor.faculty_id,
          sex: this.instructor.sex,
          maxS: this.instructor.maxS,
        };
        console.log(instructordata);
        if (this.instructor_id == 0) {
           ProctorService.createProctor(instructordata).then((res)=>{
          console.log(res.data);
          });
        } else {
          ProctorService.updateProctor(this.instructor_id, instructordata).then(() => {
            // console.log(res.data);
            document.getElementById("closeduser").click();
            this.getProctor();
          });
        }
      }
    },
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.vertical-menu {
  background-color: #eee;
}

.vertical-menu a {
  background-color: #eee;
  color: black;
  display: block;
  padding: 12px;
  text-decoration: none;
}

.vertical-menu a:hover {
  background-color: #ccc;
}

.vertical-menu a.active {
  background-color: #04aa6d;
  color: white;
}
.card {
  margin: 0 auto; /* Added */
  float: none; /* Added */
  margin-bottom: 10px; /* Added */
}
body {
  background-color: gray;
}
</style>
